<template>
    <div>
        <div class="search-box">
            <p>论文类型：</p>
            <a-select class="input-box" allowClear v-model="searchFrom.paperTypeCode">
                <a-select-option v-for="(item,index) in lwlx" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select>
            <p>审批状态：</p>
            <a-select class="input-box" allowClear v-model="searchFrom.approvalStatus">
                <a-select-option value="1">草稿</a-select-option>
                <a-select-option value="2">已提交</a-select-option>
            </a-select>
            <p>标题：</p>
            <a-input class="input-box" v-model="searchFrom.title" />
            <p>年度：</p>
            <a-date-picker
                class="input-box"
                mode="year"
                v-model="searchFrom.publicationYear"
                :open="dataopen"
                format="YYYY年"
                :allowClear="false"
                @openChange="openChangeYear"
                @panelChange="panelChangeYear"
                :disabled="type=='look'"
            />
            <p>作者：</p>
            <a-input class="input-box" v-model="searchFrom.authors" />
            <a-button type="primary" icon="search" @click="searchList">搜索</a-button>
            <a-button type="primary" icon="download" class="right-btn" >导出Excel</a-button>
            <a-button type="primary" icon="plus" class="right-btn" @click="$router.push('/admin/research/thesis/info?type=add')">新增</a-button>
        </div>
        <a-table 
            :columns="columns" 
            :data-source="data" 
            :loading="loading"
            :pagination="pagination"
            @change="handleTableChange"
            :scroll="{ x: 1500 }"
            bordered>
            <template slot="id" slot-scope="text">
                <a class="action-btn" @click="$router.push('/admin/research/thesis/info?type=look&id='+text)">详情</a>
                <a-divider type="vertical" />
                <a class="action-btn">查看审批意见</a>
                <a-divider type="vertical" />
                <a class="action-btn" @click="$router.push('/admin/research/thesis/info?type=update&id='+text)">编辑</a>
                <a-divider type="vertical" />
                <a-popconfirm
                    title="确定删除？"
                    ok-text="确定"
                    cancel-text="取消"
                    @confirm="remove(text)"
                >
                    <a class="action-btn">删除</a>
                </a-popconfirm>
            </template>
        </a-table>
        <p class="table-tips">显示第 {{numStart}} 到第 {{numEnd}} 条记录，总共 {{pagination.total}} 条记录</p>
    </div>
</template>
<script>    
    import { getDicts } from '@/baseAPI/dictionary'
    import { list,del } from '@/baseAPI/research/thesis'

    const columns = [
        {
            title: '序号',
            align:'center',
            fixed: 'left',
            width:70,
            customRender: (text, row, index) => {
                return { children: index+1};
            },
        },
        {
            title: '状态',
            dataIndex: 'approvalStatus',
            align:'center',
            fixed: 'left',
            width:100,
            customRender: (text) => {
                if(text==1){
                    return { children: '草稿'};
                }else if(text==2){
                    return { children: '已提交'};
                }
            },
        },
        {
            title: '标题',
            dataIndex: 'title',
            align:'left',
            fixed: 'left',
            width:400,
            ellipsis: true,
        },
        {
            title: '类型',
            dataIndex: 'paperTypeName',
            align:'center',
            width:100,
        },
        {
            title: '作者',
            dataIndex: 'authors',
            width:250,
            align:'left',
            ellipsis: true,
        },
        {
            title: '机构排名',
            dataIndex: 'orgRank',
            width:100,
            align:'center'
        },
        {
            title: '年度',
            dataIndex: 'publicationYear',
            width:150,
            align:'center',
            customRender: (text) => {
                return { children: text==null?'':text+'年'};
            },
        },
        {
            title: '期刊/会议名称/学位授予单位',
            dataIndex: 'journalName',
            width:400,
            align:'left'
        },
        {
            title: '卷',
            dataIndex: 'publishVolume',
            width:150,
            align:'center'
        },
        {
            title: '期',
            dataIndex: 'publishStage',
            width:150,
            align:'center'
        },
        {
            title: '收录情况',
            dataIndex: 'collectionInfo',
            width:500,
            align:'left'
        },
        {
            title: '第一作者',
            dataIndex: 'firstAuthorName',
            width:200,
            align:'center'
        },
        {
            title: '第一作者中文',
            dataIndex: 'authors',
            width:250,
            align:'left',
            ellipsis: true,
        },
        {
            title: '通讯作者中文',
            dataIndex: 'corrAuthorChName',
            width:250,
            align:'left'
        },
        {
            title: '操作',
            fixed: 'right',
            dataIndex: 'id',
            width:300,
            scopedSlots: { customRender: 'id' }
        }

    ];
    export default {
        name: 'teacher',
        components: {
        },
        data () {
            return {
                columns,
                data:[],
                loading: false,
                pagination:{
                    pageSize: 10,
                    current: 1,
                    total:0,
                },
                searchFrom:{
                    size: '',
                    current: '',
                    authors:'',
                    paperAchieveCode:'',
                    approvalStatus:'',
                    title:'',
                    paperTypeCode:'',
                },
                dataopen: false,
                lwlx:[],
                numStart:0,
                numEnd:0,
            }
        },
        mounted () {
            getDicts({dataCode:'LWCGLX',status:true}).then(res=>{
                this.lwlx=res.data.dicts;
            })
            this.fetch()
        },
        methods:{
            handleTableChange(pagination){
                const pager = { ...this.pagination };
                pager.current = pagination.current;
                this.pagination = pager;
                this.fetch();
            },
            fetch() {
                this.loading = true;
                this.searchFrom.size=this.pagination.pageSize;
                this.searchFrom.current=this.pagination.current;
                list(this.searchFrom).then(res=>{
                    this.pagination.total = res.data.total;
                    this.data = res.data.records;
                    this.numStart=(res.data.current-1)*res.data.size+1;
                    this.numEnd=res.data.current*res.data.size>res.data.total?res.data.total:res.data.current*res.data.size;
                    this.loading = false;
                })
            },
            searchList(){
                this.pagination.current=1;
                this.fetch()
            },
            remove(id){
                del(id).then(res=>{
                    if(res.data.success){
                        this.$notification['success']({
                            message: '成功',
                            description:'删除论文成功',
                        });
                        this.fetch()
                    }else{
                        this.$notification['error']({
                            message: '失败',
                            description:res.data.errorMessage,
                        });
                    }
                })
            },
            // 点击选择框事件 弹出日期组件选择年
            openChangeYear(status) {
                if (status) {
                    this.dataopen = true;
                } else {
                    this.dataopen = false;
                }
            },
            // 选择年之后 关闭弹框
            panelChangeYear(value){
                this.searchFrom.publicationYear = this.getTimeStr(value._d,'yyyy') ;
                this.dataopen = false;
            },

        }
    }
</script>
<style scoped>
    .search-box
    {
        padding-bottom: 24px;
        border-bottom: 1px solid rgba(151,151,151,0.60);
        margin-bottom: 24px;
    }
    .search-box p
    {
        display: inline-block;
    }
    .search-box .right-btn
    {
        float: right;
        margin-left: 1rem;
    }
    .search-box .input-box{
        margin-right: 1rem;
        width: 10rem;
    }
    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 14px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .table-tips{
        margin-top: -48px;
        line-height: 32px;
        padding-left: 15px;
        color: #444;
    }
    .ant-table-wrapper .show-input{
        height: 23px;
        line-height: 23px;
    }
    .ant-table-wrapper .show-input >>> .ant-select-selection{
        background-color: transparent;
        border: none;
        color: rgba(0, 0, 0, 0.65);
    }
    .ant-table-wrapper .show-input >>> .ant-select-arrow{
        display: none;
    }
    .ant-table-wrapper .show-input{
        height: 23px;
        line-height: 23px;
    }
    .ant-table-wrapper .show-input >>> .ant-select-selection{
        background-color: transparent;
        border: none;
        color: rgba(0, 0, 0, 0.65);
    }
    .ant-table-wrapper .show-input >>> .ant-select-arrow{
        display: none;
    }


</style>
